import { asyncRouterMap, constantRouterMap } from 'src/router';

function hasPermission(permission, route) {
  if (route.permission) {
    return route.permission.indexOf(permission)>-1 ? true : false
  } else {
    return true
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },

  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },

  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { promotorType } = data;
        const { accountState } = data;
        // console.log(promotorType, accountState)
        const permission = promotorType * 10 + accountState
        if (promotorType) {
          const accessedRouters = asyncRouterMap.filter(v => {
            if (hasPermission(permission, v)) {
              if (v.children && v.children.length > 0) {
                v.children = v.children.filter(child => {
                  if (hasPermission(permission, child)) {
                    return child
                  }
                  return false;
                });
                return v
              } else {
                return v
              }
            }
          })
          commit('SET_ROUTERS', accessedRouters);
        }       
        resolve()
      })
    }
  }
};


export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js